var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"spread-block-shadow","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Тень_Блока"}},[_c('image',{attrs:{"width":"291","height":"218","transform":"translate(111.05 202)","href":`${_vm.$CONST.cnstrAssetsUrl}/preview-layers/spread/block/shadow/DPH26_1.webp`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }